import React, { useState } from "react";
import {Container} from "@mui/material";
import Api, {APIs} from "../../Api";

interface IProps {
    pid: string;
}

const ProjectPC1Upload: React.FC<IProps> = ({ pid }) => {
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [uploadStatus, setUploadStatus] = useState<string>("");
    const [errorMessage, setErrorMessage] = useState<string>("");

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setErrorMessage(""); // Clear previous errors
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];
            const validTypes = ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];

            if (validTypes.includes(file.type)) {
                setSelectedFile(file);
            } else {
                setSelectedFile(null);
                setErrorMessage("Please upload a valid file (PDF or DOC only).");
            }
        }
    };

    const handleUpload = async () => {
        if (!selectedFile) {
            alert("Please select a file to upload.");
            return;
        }

        setUploadStatus("Uploading...");

        try {
            const formData = new FormData();
            formData.append("file", selectedFile);
            formData.append("pid", pid);
            const url = Api.getURL(APIs.MoPD_UPLOAD_PC1,{pid:pid})
            const response = await fetch(url, {
                method: "POST",
                body: formData,
            });

            if (response.ok) {
                setUploadStatus("Upload successful!");
            } else {
                setUploadStatus("Failed to upload file.");
            }
        } catch (error) {
            console.error("Error uploading file:", error);
            setUploadStatus("An error occurred while uploading.");
        }
    };

    return (
        <Container sx={{m:3, p:2}}>
            <h3>Upload PC-1 Document for Project: {pid}</h3>
            <input
                type="file"
                accept=".pdf,.doc,.docx"
                onChange={handleFileChange}
            />
            <button onClick={handleUpload} disabled={!selectedFile}>
                Upload
            </button>
            {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
            {uploadStatus && <p>{uploadStatus}</p>}
        </Container>
    );
};

export default ProjectPC1Upload;
